<!--
 * @Author: OP070278 ZHANG.CHENG@opple.com
 * @Date: 2024-08-23 11:07:53
 * @LastEditors: OP070278 ZHANG.CHENG@opple.com
 * @LastEditTime: 2024-08-27 15:43:13
 * @FilePath: /com_light2_web/src/components/common/layer/OpCol.vue
 * @Description: 栅格布局容器
-->
<template>
  <div :class="colClasses" :style="colStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OpCol',
  props: {
    xs: {
      type: Number,
      default: 4
    },
    md: {
      type: Number,
      default: 8
    },
    lg: {
      type: Number,
      default: 24
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    gutter: function gutter() {
      var parent = this.$parent;
      while (parent && parent.$options.name !== 'OpRow') {
        parent = parent.$parent;
      }
      return parent ? parent.gutter : 0;
    },
    colClasses() {
      return [
        `op-col-xs-${this.xs}`,
        `op-col-md-${this.md}`,
        `op-col-lg-${this.lg}`
      ];
    },
    colStyle() {
      const gutter = this.gutter || 0;
      return {
        paddingLeft: gutter ? `${gutter / 2}px` : '0',
        paddingRight: gutter ? `${gutter / 2}px` : '0',
        ...this.customStyle
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import './css/opcol.scss';

[class*="op-col-"] {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
